export function SiteLogo({ priority = false }: { priority?: boolean }) {
  return <img
    className="brand-logo"
    src="/images/beda-healthcare-logo.png"
    alt="BEDA Healthcare"
    width={1755}
    height={896}
    loading={priority ? 'eager' : 'lazy'}
    decoding="async"
    fetchPriority={priority ? 'high' : 'auto'}
  />;
}
